import React from 'react'
import { useApplicationContext } from '../../../provider'
import { useLocation } from '@reach/router'
import { Button } from '@paypalcorp/pp-react-buttons'

export const LoggedIn = ({ children }) => {
  const { user } = useApplicationContext()
  const { pathname } = useLocation()

  return user?.loggedIn ? (
    children
  ) : (
    <Button
      size="sm"
      as="a"
      href={`https://www.paypal.com/signin?returnUri=https%3A%2F%2Fdeveloper.paypal.com${pathname}&intent=developer`}
    >
      Log in
    </Button>
  )
}

export default LoggedIn
